module.exports = __webpack_public_path__ + "img/hint-key.94170a0a.svg";